<template>
  <SheetModal
    class="StartSeasonModalView"
    data-theme="light"
    aria-label="New season"
    :aria-busy="isRequesting || isSaving"
    @close="$emit('close')"
  >
    <SeasonFormView
      v-model:isRequesting="isRequesting"
      title="Start a season"
      @cancel="$emit('close')"
      @submit="handleSubmit"
    />
  </SheetModal>
</template>

<script lang="ts" setup>
import SheetModal from "@/components/SheetModal.vue";
import { supabaseClient } from "@/lib/database/supabase";
import { RouteName } from "@/lib/router/routes";
import useModalStore from "@/stores/useModalStore";
import useRunCarouselStore from "@/stores/useRunCarouselStore";
import useSeasonStore from "@/stores/useSeasonStore";
import { SeasonFormPayload } from "@/views/commish/SeasonFormView.types";
import SeasonFormView from "@/views/commish/SeasonFormView.vue";
import { ref } from "vue";

defineEmits<{
  close: [],
}>();

const {
  replaceModal,
} = useModalStore();

const {
  fetchRun,
} = useRunCarouselStore();

const {
  fetchHomeSeasons,
} = useSeasonStore();

const isRequesting = ref(true);
const isSaving = ref(false);

async function handleSubmit (payload: SeasonFormPayload | undefined) {
  if (!payload) return;

  isSaving.value = true;

  const {
    data: season,
    error,
  } = await supabaseClient
    .from("seasons")
    .insert(payload.season)
    .select()
    .single();

  if (error) {
    alert(error.message);
  } else {
    const {
      data: run,
      error: runError,
    } = await supabaseClient.rpc("insert_run_with_crews", {
      ...payload.run,
      season_id: season.id,
    });

    if (runError) alert(runError.message);

    if (run) fetchRun(run.id);
    fetchHomeSeasons();

    replaceModal({
      name: RouteName.seasonSchedule,
      params: {
        seasonId: season.id,
      },
    });
  }

  isSaving.value = false;
}
</script>
